var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKatalonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katalon_icon_26px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_katalon"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#6BB545",
    points: "0.000743460265 25.9998514 9.64416656 25.9998514 9.64416656 -0.000148571429 0.000743460265 -0.000148571429"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#00A9FF",
    points: "16.3890771 10.5461748 9.81371107 0.000297142857 0 0.000297142857 11.931121 19.1370891"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#00A9FF",
    points: "18.8724693 14.1446686 13.6692604 22.1526428 16.2628427 26.1446686 26.6692604 26.1446686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#9BCA3B",
    points: "0 25.9997029 9.74953022 25.9997029 26 -0.000297142857 16.2497181 -0.000297142857"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalonIcon);
export default __webpack_public_path__ + "static/media/katalon_icon.5689d9beb9ca3d473e7119187dc0fb1e.svg";
export { ForwardRef as ReactComponent };